import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Form } from '@unform/web';
import { includes, isArray } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner, Table } from '~/components';
import {
  Input,
  Combobox,
  DateTime,
  Autocomplete,
  Select,
  Hidden,
} from '~/components/Form';
import {
  CENTRO_CUSTO_ABASTECIMENTO,
  MOTORISTA_ABASTECIMENTO,
  LOCALIDADE_ABASTECIMENTO,
  MODULO_20_GRAUS,
  TRR_CHILE,
  CUSTOMIZACAO_RAIZEN,
} from '~/constants/modules';
import { t, can } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import api from '~/services/api';

import { Container } from './styles';

export default function CreateOrUpdate({
  data,
  reference,
  close,
  cancelarAcao,
}) {
  const { client } = useSelector((state) => state.user.profile);
  const [posto, setPosto] = useState(0);
  const [motorista, setMotorista] = useState(null);
  const [totalizador, setTotalizador] = useState(0);
  const [custo, setCusto] = useState(null);

  const { internounidatausuario, formaidfrentistaabast } = useSelector(
    (state) => state.user.configs
  );

  // const tudo = useSelector((state) => state.user.profile);

  const [
    itemsobslibintegraatendimentolubrificacao,
    setItemsobslibintegraatendimentolubrificacao,
  ] = useState([]);

  const [controla20graus, setControla20graus] = useState(0);
  const [operabastecimento20posto, setOperabastecimento20posto] = useState(0);

  const [loading, setLoading] = useState(true);
  const [initials, setInitials] = useState(null);
  const [idatendimento, setIdatendimento] = React.useState(null);
  const [
    idatendimentoabastecimento,
    setIdatendimentoabastecimento,
  ] = React.useState(null);
  const [idposto, setIdposto] = React.useState(null);
  const [antifurtoabastecimento, setAntifurtoabastecimento] = React.useState(
    null
  );
  const [chipabastecimento, setChipabastecimento] = React.useState(null);
  const [visorabastecimento, setVisorabastecimento] = React.useState(null);
  const [idmovimentacao, setIdmovimentacao] = React.useState(null);
  const [carregou, setCarregou] = React.useState(false);

  const [
    statuslibintegraatendimentoabastecimento,
    setStatuslibintegraatendimentoabastecimento,
  ] = React.useState(0);

  const optionsAprovacao = useMemo(() => {
    if (statuslibintegraatendimentoabastecimento === 3) {
      return [{ value: '4', label: t('s.geral.opcoes.reenvioparaaprovacao') }];
    }

    return [
      { value: '1', label: t('s.geral.opcoes.pendente') },
      { value: '2', label: t('s.geral.opcoes.aprovado') },
      { value: '3', label: t('s.geral.opcoes.naoaprovado') },
      // { value: '4', label: t('s.geral.opcoes.reenvioparaaprovacao') },
    ];
  }, [statuslibintegraatendimentoabastecimento, t]);

  // const optionsAprovacao = useMemo(
  //   () => [
  //     { value: '1', label: t('s.geral.opcoes.pendente') },
  //     { value: '2', label: t('s.geral.opcoes.aprovado') },
  //     { value: '3', label: t('s.geral.opcoes.naoaprovado') },
  //     { value: '4', label: t('s.geral.opcoes.reenvioparaaprovacao') },
  //   ],
  //   [statuslibintegraatendimentoabastecimento]
  // );

  const cellsHistorico = useMemo(
    () => [
      {
        id: 'obsatendimentoabastecimentohistoricomsg',
        label: t(
          's.operacao.checkliberadoparaintegracao.obslibintegraatendimentoabastecimento'
        ),
      },
      {
        id: 'dataeventoatendimentoabastecimentohistoricomsg',
        label: t(
          's.operacao.checkliberadoparaintegracao.obslibintegraatendimentoabastecimento'
        ),
      },
    ],
    []
  );

  useEffect(() => {
    if (initials) {
      // console.log(JSON.stringify(initials));

      setPosto(initials.idposto);
      // setControla20graus(value.controla20grausposto);
      // setOperabastecimento20posto(value.operabastecimento20posto);
      setTotalizador(Number(initials.tipototalizadorveiculo));

      handleResponseDataItemsAbastecimentohistoricomsg(
        initials.idposto,
        initials.idatendimento
      );
    }
  }, [initials]);

  useEffect(() => {
    if (carregou) {
      if (initials) {
        const updatedInitials = {
          ...(initials || {}),
          campo_antifurtoabastecimento: antifurtoabastecimento,
          campo_chipabastecimento: chipabastecimento,
          campo_visorabastecimento: visorabastecimento,
        };
        setInitials(updatedInitials);
        setCarregou(false);
      }
    }
  }, [carregou]);

  useEffect(() => {
    async function handleCarregaMovimentacaoAtendimento(
      idmovimentacao,
      idatendimento,
      idposto
    ) {
      const { data } = idmovimentacao
        ? await api.get(
            `pitstop/abastecimento/movimentacao/${idmovimentacao}/${idposto}`
          )
        : await api.get(`pitstop/abastecimento/${idatendimento}/${idposto}`);
      setIdmovimentacao(idmovimentacao);
      setIdatendimento(idatendimento); // data.idatendimento
      setInitials(data);
    }
    if (data != null) {
      setStatuslibintegraatendimentoabastecimento(
        data.statuslibintegraatendimentoabastecimento
      );

      handleCarregaMovimentacaoAtendimento(
        data.idmovimentacao,
        data.idatendimento,
        data.idposto
      );

      // console.log(JSON.stringify(data))
    }
  }, [data]);

  useEffect(() => {
    async function handleCarregaAbastecimento(idatendimento) {
      const { data } = await api.get(`/pitstop/abastecimento/${idatendimento}`);
      setIdatendimentoabastecimento(data.idatendimentoabastecimento);
      setIdposto(data.idposto);
      setAntifurtoabastecimento(data.antifurtoabastecimento);
      setChipabastecimento(data.chipabastecimento);
      setVisorabastecimento(data.visorabastecimento);
      setCarregou(true);
      setLoading(false);
    }
    if (idatendimento) {
      handleCarregaAbastecimento(idatendimento);
    }
  }, [idatendimento]);

  async function handleCloseModal() {
    await this.setState({ open: false });
  }

  async function hancleCancelarAcao() {
    await this.setState((prevState) => ({
      ...prevState,
    }));
  }

  const valorSelecionado = (campo) => {
    const valor = document.getElementById(campo).innerText;
    if (valor === '') {
      return null;
    }
    const option = optionsAprovacao.find((item) => item.label === valor);
    return option ? option.value : null;
  };

  function selectItemByValue(selectId, value) {
    if (value) {
      const selectElement = document.getElementById(selectId);
      if (selectElement) {
        for (const option of selectElement.options) {
          if (option.value === value) {
            option.selected = true;
            break;
          }
        }
      }
    }
  }

  const handleResponseDataItemsAbastecimentohistoricomsg = useCallback(
    async (idposto, idatendimento) => {
      try {
        if (idposto) {
          setLoading(true);

          await api
            .get(
              `/pitstop/atendimentoabastecimentohistoricomsg/${idposto}/${idatendimento}`
            )
            .then((response) =>
              setItemsobslibintegraatendimentolubrificacao(response.data)
            );
        }
      } catch (err) {
        getToastErrors(err);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        obslibintegraatendimentoabastecimento: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        statuslibintegraatendimentoabastecimento: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        idatendimentoabastecimento,
        idatendimento,
        idcliente: client,
        idposto,
        obslibintegraatendimentoabastecimento:
          param.obslibintegraatendimentoabastecimento,
        statuslibintegraatendimentoabastecimento: valorSelecionado(
          'statuslibintegraatendimentoabastecimento'
        ),
        idmovimentacao,
      };
      await api.put(
        'pitstop/alteraatendimentoabastecimentoconfirmaadm',
        objSend
      );
      await close();
      toast.success(t('s.geral.sucessoalteracao'));
    } catch (err) {
      if (err && isArray(err)) {
        toast.error(err[0]);
      }
      await cancelarAcao();
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });
        reference.current.setErrors(validationErrors);
      }
    }
  }

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <>
          <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
            <Container>
              <Autocomplete
                name="idposto"
                disabled
                disableClearable
                label="codigonomeposto"
                url="postoscomboios"
                unique="idposto"
                title={t('s.menu.configuracao.posto')}
              />

              <Combobox
                name="idbico"
                disabled
                label="bicoprodutobico"
                url="bicos"
                unique="idbico"
                title={t('s.menu.configuracao.bico')}
                hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
                params={{
                  wherefield: ['idposto', 'tipoproduto'],
                  valuewherefield: [posto?.idposto, 'C'],
                  typewherefield: ['EQUALS', 'EQUALS'],
                  fieldlist: 'idbico, idterminal, idproduto, bicoprodutobico',
                }}
              />

              <DateTime
                time
                name="datahorainicialmovimentacao"
                disabled
                label={t(
                  's.operacao.abastecimento.datahorainicialmovimentacao'
                )}
              />

              <DateTime
                time
                name="datahorafinalmovimentacao"
                disabled
                label={t('s.operacao.abastecimento.datahorafinalmovimentacao')}
                style={{ marginTop: 16 }}
              />

              <Input
                name="idveiculo"
                disabled
                label={
                  !can(TRR_CHILE)
                    ? t('s.operacao.abastecimento.idveiculo')
                    : t('s.cadastro.codigoempresacliente')
                }
                style={{ marginTop: 16 }}
              />

              <Autocomplete
                name="idempresaveiculo"
                label={
                  can(CUSTOMIZACAO_RAIZEN)
                    ? 'idempresaveiculo'
                    : 'nomeempresaveiculo'
                }
                url="empresasveiculos"
                unique="idempresaveiculo"
                title={t('s.cadastro.veiculo.idempresaveiculo')}
                disabled
              />

              {can(CENTRO_CUSTO_ABASTECIMENTO) && (
                <Input
                  name="idcentrocusto"
                  disabled
                  label={t('s.operacao.abastecimento.idcentrocusto')}
                  value={custo}
                />
              )}

              {can(LOCALIDADE_ABASTECIMENTO) && (
                <Autocomplete
                  name="idlocalidade"
                  label="nomelocalidade"
                  url="localidades"
                  unique="idlocalidade"
                  title="Localidade"
                  disabled
                />
              )}

              <Input
                name="totalizadormovimentacaoabastecimento"
                type="number"
                disabled
                label={t(
                  `s.operacao.abastecimento.${
                    totalizador === 1 ? 'horimetro' : 'hodometro'
                  }`
                )}
                style={{
                  display: includes([1, 2], totalizador) ? 'block' : 'none',
                }}
              />

              <Input
                name="encerranteinicialmovimentacao"
                disabled
                label={t(
                  's.operacao.abastecimento.encerranteinicialmovimentacao'
                )}
                type="number"
              />

              <Input
                name="encerrantefinalmovimentacao"
                disabled
                label={t(
                  's.operacao.abastecimento.encerrantefinalmovimentacao'
                )}
                type="number"
              />

              <Input
                name="volumemovimentacao"
                disabled
                label={t('s.operacao.abastecimento.volumemovimentacao')}
                type="number"
              />

              {formaidfrentistaabast !== 0 && (
                <Input
                  name="codigousuario"
                  disabled
                  label={t('s.operacao.abastecimento.codigousuario')}
                />
              )}

              {can(MOTORISTA_ABASTECIMENTO) && (
                <Input
                  name="idmotorista"
                  disabled
                  label={t('s.operacao.abastecimento.idmotorista')}
                  value={motorista}
                />
              )}

              {can(MODULO_20_GRAUS) &&
                controla20graus === 1 &&
                operabastecimento20posto === 1 && (
                  <>
                    <Input
                      name="temperaturamediamovimentacao"
                      type="number"
                      disabled
                      label={t('s.operacao.abastecimento.temperaturamedia')}
                    />
                    <Input
                      name="densidade20movimentacao"
                      type="number"
                      disabled
                      label={t('s.operacao.abastecimento.densidade20')}
                    />
                    <Input
                      name="volume20movimentacao"
                      type="number"
                      disabled
                      label={t('s.operacao.abastecimento.volume20movimentacao')}
                    />
                  </>
                )}

              <Select
                name="statuslibintegraatendimentoabastecimento"
                id="statuslibintegraatendimentoabastecimento"
                label={t(
                  's.operacao.checkliberadoparaintegracao.statuslibintegraatendimentoabastecimento'
                )}
                options={optionsAprovacao}
                // defaultValue={antifurtoabastecimento}
                style={{ marginTop: 8 }}
                getValue={(value) => setAntifurtoabastecimento(value)}
              />

              <Input
                id="obslibintegraatendimentoabastecimento"
                name="obslibintegraatendimentoabastecimento"
                label={t(
                  's.operacao.checkliberadoparaintegracao.obslibintegraatendimentoabastecimento'
                )}
                multiline
                rows={3}
                inputProps={{ maxLength: 255 }}
                style={{ marginTop: 12 }}
              />

              {/*
              <Select
                disabled
                name="campo_antifurtoabastecimento"
                id="campo_antifurtoabastecimento"
                label={t('s.cadastro.pitstop.antifurtoabastecimento')}
                options={optionsOk}
                defaultValue={antifurtoabastecimento}
                style={{ marginTop: 8 }}
                getValue={(value) => setAntifurtoabastecimento(value)}
              />

              <Select
                disabled
                name="campo_chipabastecimento"
                id="campo_chipabastecimento"
                label={t('s.cadastro.pitstop.chipabastecimento')}
                options={optionsOk}
                defaultValue={chipabastecimento}
                style={{ marginTop: 12 }}
                getValue={(value) => setChipabastecimento(value)}
              />

              <Select
                disabled
                name="campo_visorabastecimento"
                id="campo_visorabastecimento"
                label={t('s.cadastro.pitstop.visorabastecimento')}
                options={optionsOk}
                defaultValue={visorabastecimento}
                style={{ marginTop: 12 }}
                getValue={(value) => setVisorabastecimento(value)}
              />

              <Input
                disabled
                name="observacaoabastecimento"
                label={t('s.cadastro.pitstop.observacaoatendimento')}
                multiline
                rows={3}
                inputProps={{ maxLength: 255 }}
                style={{ marginTop: 12 }}
              /> */}

              <Hidden name="idatendimento" devaultValue={idatendimento} />
              <Hidden
                name="idatendimentoabastecimento"
                devaultValue={idatendimentoabastecimento}
              />
            </Container>
          </Form>

          <Table
            isResponsive
            size="small"
            height="18rem"
            paginate={99}
            showPagination={false}
            cells={cellsHistorico}
            data={itemsobslibintegraatendimentolubrificacao ?? []}
            loding={loading}
          />
        </>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
